<template>
  <div class="direct">
    <!-- 选择团队和销售 -->
    <div class="direct-sales">
      <Sale
        v-model="sale"
        class="direct-sales-cascader"
        :loading="loading"
        @change="handleSaleChange"
      />
    </div>

    <!-- 业绩 -->
    <Performance
      :performance="performance"
      :loading="loading"
      @show-detail="handlePerformanceDetail"
    />

    <!-- 图表 -->
    <Chart />

    <!-- 漏斗和排行 -->
    <div class="direct-footer">
      <!-- 下线本月产品转换漏斗王晓阳 -->
      <!-- <Funnel
        class="direct-funnel"
        :dataSource="funnel"
      /> -->
      <Top
        class="direct-rank"
        :dataSource="rank"
      />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import Sale from '../components/Sale/Index';
import Performance from './components/Performance/Index';
import Chart from './components/Chart/Index';
import Funnel from './components/Funnel/Index';
import Top from './components/Top/Index';

import requestMixin from './mixins/request';

const { mapState, mapActions } = createNamespacedHelpers(
  'directSaleReport/dataView',
);

export default {
  components: {
    Sale,
    Performance,
    Chart,
    Funnel,
    Top,
  },

  mixins: [requestMixin],

  data() {
    return {
      loading: false,
      // 业绩
      performance: {},
      // 漏斗
      funnel: {},
      // 排行
      rank: {},
    };
  },

  computed: {
    ...mapState({
      storeSale: (state) => state.sale,
    }),

    // 销售信息
    sale: {
      get(state) {
        return this.storeSale;
      },
      set(newVal) {
        this.updateSale(newVal);
      },
    },
  },

  created() {
    // 获取当前登录用户的业绩数据
    // const { department_id, id } = this.user;
    // this.updateSale([department_id, id]);
    this.queryDirectPerformance();
    this.queryDirectFunnel();
    this.queryDirectRanking();
  },

  methods: {
    ...mapActions(['updateSale', 'updateVisible']),

    // 选择团队和销售
    handleSaleChange() {
      this.queryDirectPerformance();
      this.queryDirectFunnel();
    },

    // 查看业绩详情
    handlePerformanceDetail(date) {
      this.$router.push({
        path: '/data-report/direct-detail',
        query: {
          saleId: this.sale[1],
          departmentId: this.sale[0],
          date,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.direct {
  display: flex;
  flex-direction: column;
  // align-items: center;

  &-sales {
    width: 100%;
    display: flex;
    // justify-content: flex-end;

    &-cascader {
      width: 400px;
    }
  }

  &-footer {
    margin: 0;
    // 新增
    width: 100%;
    display: flex;
  }

  &-funnel {
    width: 544px;
    float: left;
    box-sizing: border-box;
    margin: 0 22px 22px 0;
  }

  &-rank {
    width: 544px;
    float: left;
    box-sizing: border-box;
  }
}
</style>